import FetchService from "./Shared/FetchService";
import TranscriptCourseLiteDomainService from "../Domain/TranscriptCourseLite/TranscriptCourseLite.service";
const BASE_URL = "/aviso/transcriptCourse";
export default class TranscriptCourseService {
    static search(search, options = {}) {
        return FetchService.getPagedResponse(BASE_URL + "/search", {
            ids: search.ids,
            courseSectionIds: search.courseSectionIds,
            termAttendanceStatusIds: search.termAttendanceStatusIds,
            lastAttendanceDateFrom: search.lastAttendanceDateFrom,
            lastAttendanceDateTo: search.lastAttendanceDateTo,
            hasAttended: search.hasAttended,
            max: options === null || options === void 0 ? void 0 : options.max,
            offset: options === null || options === void 0 ? void 0 : options.offset,
            sort: options === null || options === void 0 ? void 0 : options.sort,
            order: options === null || options === void 0 ? void 0 : options.order,
        }).then((resp) => {
            var _a;
            return (Object.assign(Object.assign({}, resp), { 
                // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'datum' implicitly has an 'any' type.
                data: (_a = resp.data) === null || _a === void 0 ? void 0 : _a.map((datum) => (Object.assign(Object.assign({}, datum), { transcriptCourse: TranscriptCourseLiteDomainService.fromJSON(datum.transcriptCourse) }))) }));
        });
    }
    static markTermAttendanceStatus(transcriptCourseIds, termAttendanceStatusId) {
        return FetchService.postSingleResponse(BASE_URL + "/markTermAttendanceStatus", {
            transcriptCourseIds,
            termAttendanceStatusId,
        });
    }
}
